import $ from 'jquery';
import './lazyload-object-fit-polyfill-fix';
import 'lazyloadxt/src/jquery.lazyloadxt';
import './lazyload-srcset-responsiveimage';
import 'lazyloadxt/src/jquery.lazyloadxt.bg';

$.extend($.lazyLoadXT, {
  edgeY: 900,
  blankImage: 'data:image/gif;base64,R0lGODdhAQABAIABABcXF////ywAAAAAAQABAAACAkQBADs=',
  updateEvent: 'load orientationchange resize scroll touchmove focus brandhubParallaxScrollPos',
});

export default {
  $,
  lazyLoadXT: $.lazyLoadXT,
};



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/lazyload/lazyload.js